import React from 'react';
import OrderList from '../order/OrderList';

const DashboardPage = () => {
  return <OrderList />;
};

export default DashboardPage;
